"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInjectionStatus = exports.setInjected = void 0;
/**
 * Stores a boolean in localStorage with type safety.
 */
var setInjected = function (key) {
    localStorage.setItem("bonkInject:".concat(key), JSON.stringify(true));
};
exports.setInjected = setInjected;
/**
 * Reads a value from localStorage and ensures it is a boolean.
 * Returns a default value if the key doesn't exist.
 */
var getInjectionStatus = function () {
    var streamingServer = localStorage.getItem("bonkInject:streamingServer") !== null;
    var addons = localStorage.getItem("bonkInject:addons") !== null;
    return { streamingServer: streamingServer, addons: addons };
};
exports.getInjectionStatus = getInjectionStatus;
